import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { getSoIdNumber, toFixedIfNull } from '../../../../../helpers'
import {
	selectAssetTailDigits,
	selectLatestRatesBidAsk,
	selectLotSize
} from '../../../../../store/redusers/assets/selectors'
import {
	selectPipValue,
	selectUsedMargin
} from '../../../../../store/redusers/orders/selectors'
import { selectUserCurrency } from '../../../../../store/redusers/user/selectors'
import { AppOrderItem } from '../../../../AppOrderItem'

const SidebarPendingOrderDataView = memo(({ lots, asset, orderId }) => {
	const latestRatesBidAsk = useSelector(selectLatestRatesBidAsk(asset.assetSoId))
	const bidRate = latestRatesBidAsk.bid
	const askRate = latestRatesBidAsk.ask
	const soId = getSoIdNumber(asset.assetSoId)
	const tailDigits = useSelector(selectAssetTailDigits(asset.assetType, asset.assetSoId)) || 0
	const pipValue = useSelector(selectPipValue) || 0
	const usedMargin = useSelector(selectUsedMargin) || 0
	const loginUserCurrency = useSelector(selectUserCurrency)
	const spread  =  Math.abs(parseFloat(askRate - bidRate))
		.toFixed(tailDigits).slice(0, tailDigits + 2)
	const assetLotSize = useSelector(selectLotSize(soId))
	const tradeSize = +lots * assetLotSize

	return (
		<Grid container sx={{ borderTop: '1px solid #F6F7F9', mt: 4, pt: 2 }}>
			<AppOrderItem title={'Trade Size'} value={!isNaN(tradeSize) ? toFixedIfNull(tradeSize, 4) : 0}/>
			<AppOrderItem title={'Spread'} value={toFixedIfNull(spread, 4)}/>
			<AppOrderItem
				title={'Pip Value'}
				value={!isNaN(pipValue) ? toFixedIfNull(pipValue, 10) : 0}
				currency={loginUserCurrency}
				valueFull={pipValue}
			/>
			<AppOrderItem
				title={'Used Margin'}
				value={!isNaN(usedMargin) ? toFixedIfNull(usedMargin, 10) : 0}
				currency={loginUserCurrency}
				valueFull={usedMargin}
			/>
			{orderId ? <AppOrderItem title={'Order ID'} value={orderId} /> : null}
		</Grid>
	)
})

SidebarPendingOrderDataView.propTypes = {
	asset: PropTypes.object,
	lots: PropTypes.number,
	orderId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	])
}

SidebarPendingOrderDataView.displayName = 'SidebarPendingOrderDataView'

export default SidebarPendingOrderDataView


